'use client';

import { useState } from 'react';
import Icon from '@/components/ui/AppIcon';

interface WarningBannerProps {
  dismissible?: boolean;
}

const WarningBanner = ({ dismissible = true }: WarningBannerProps) => {
  const [dismissed, setDismissed] = useState(false);

  if (dismissed) return null;

  return (
    <div
      className="w-full bg-accent text-accent-foreground px-4 py-2 flex items-center justify-between gap-4"
      style={{ zIndex: 400 }}
      role="alert"
      aria-live="polite"
    >
      <div className="flex items-center gap-2 flex-1 min-w-0">
        <Icon name="ExclamationTriangleIcon" size={18} variant="solid" className="shrink-0" />
        <p className="font-caption text-sm font-medium truncate sm:whitespace-normal">
          <span className="font-semibold">INTERNAL TOOL ONLY</span>
          <span className="hidden sm:inline"> — This is a temporary administrative interface. Do not share access or use in production environments.</span>
          <span className="sm:hidden"> — Temporary admin interface. Not for production use.</span>
        </p>
      </div>
      {dismissible && (
        <button
          onClick={() => setDismissed(true)}
          className="shrink-0 p-1 rounded hover:bg-black/10 transition-colors duration-150 focus:outline-none focus:ring-2 focus:ring-accent-foreground focus:ring-offset-1"
          aria-label="Dismiss warning"
        >
          <Icon name="XMarkIcon" size={16} variant="outline" />
        </button>
      )}
    </div>
  );
};

export default WarningBanner;